// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderMemoCard(props) {
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(OrderEditForm.InputTextArea.make, {
      field: "Note",
      label: I18n.t("Internal memo")
    }),
    title: "Note"
  });
}

let make = React.memo(OrderMemoCard);

export {
  make,
}
/* make Not a pure module */
